/** Filter marketplace listings by free-text query (name, description, category, tags, brand). */
export function filterProductsByQuery(products, query) {
  const q = (query || "").toLowerCase().trim();
  if (!q) return Array.isArray(products) ? products : [];
  return (products || []).filter((p) => {
    const name = (p.name || "").toLowerCase();
    const desc = String(p.description || "")
      .replace(/<[^>]+>/g, " ")
      .toLowerCase();
    const cat = (p.category || "").toLowerCase();
    const tags = (p.tags || "").toLowerCase();
    const brand = (p.brand || "").toLowerCase();
    return (
      name.includes(q) ||
      desc.includes(q) ||
      cat.includes(q) ||
      tags.includes(q) ||
      brand.includes(q)
    );
  });
}

export function buildSearchUrl(query) {
  const q = (query || "").trim();
  if (!q) return "/search";
  return `/search?q=${encodeURIComponent(q)}`;
}
